import { get, } from '.';

export function GetCallEvents(options = {}) {
	return get<any>("/app/api/call_events", options);
}
